<template>
  <panel title="Group Library" >
    <v-layout 
    row
   >
      <v-flex
      xs-6
      text-xs-left
      class="subheading font-weight-bold"
      ml-3
      py-0
      >
      <div>  Select Group </div>
    </v-flex> 
     <v-flex
      text-xs-right
      xs-3
      mr-1
      pr-2
      >
      <v-btn
      slot="action"
      :color="strongColor"
      :to="{
        name: 'groups-create'
      }"
      class="createButton"
      dark
      large
      right>
      Create Group
    </v-btn>
     </v-flex>
    </v-layout>
    <div v-if="groups && groups.length > 0">
      <v-layout 
      mt-0
      row>
        <v-flex 
        xs12 >
          <v-card 
          flat>
            <v-list>
             <v-list-tile
                v-for="group in groups"
                :key="group.id" 
                :to="{
                name: 'group',
                params: {
                groupId: group.id
                }
                }"
                class="group">
                <v-list-tile-content>
                  <v-list-tile-title 
                  class="body-2 text-xs-left"             
                  v-text="group.name"/>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </div> 
    <div 
      v-else>
      <v-flex>
      No matching results
      </v-flex>
    </div>
  </panel>
</template>

<script>
import GroupsService from '@/services/GroupsService'
import EventBus from '@/main.js'
import { STRONG_COLOR } from '@/components/globals/consts'

export default {
	data () {
		return {
      groups: null,
      checkedGroup: null,
      strongColor: STRONG_COLOR
		}
	},
	watch: {
		'$route.query.search': {
			immediate: true,
			async handler (value) {
        try {       
          let tempGroups = (await GroupsService.index(value)).data
          if (tempGroups) {
            this.groups = tempGroups
          }
        } catch (e) {console.log(`error ${e}`)}
			}
    },
    'checkedGroup': {
      immediate: true,
      async handler () {
          if (this.checkedGroup != null) {
            await this.emitMethod('passedGroup', this.checkedGroup)
          }
      }
    }
    
  },
  async created () {
    if (this.groups) {
      this.groups = this.groups.sort(this.orderByName)
    }
  },
  beforeDestroy() {
    try {
      this.groups = null
      this.checkedGroup = null 
    } catch (err) {
      console.log(err);
    }
  },

  methods: {
    async emitMethod (name, value) {
      await EventBus.$emit(name, value)
    },
    orderByName (a, b) {
      if (a.name > b.name) {
        return 1
      } else if (a.name < b.name) {
        return -1
      }
      return 0
   }
  }
  
}
</script>

<style scoped>
.groupNames {
  text-decoration: underline;
  font-size: 14px;
  text-align: left;
}
.header {
  font-size: 16px;
  font-weight: bold;
}
.createButton {
  font-size: 16px;
  font-weight: bold;
}
.selectGroup {
  font-size: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Groups/GroupsPanel.vue